module.exports = __webpack_public_path__ + "static/dlt.168e83bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dlt.png
// module id = 1148
// module chunks = 213534597649335